import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["circle", "check", "ring", "title"]

  connect() {
    // Reset all elements to invisible
    this.circleTarget.style.transform = "scale(0)"
    this.circleTarget.style.opacity = "0"
    this.checkTarget.style.transform = "scale(0)"
    this.checkTarget.style.opacity = "0"
    this.ringTarget.style.opacity = "0"
    this.titleTarget.style.opacity = "0"
    this.titleTarget.style.transform = "translateY(10px)"

    // Sequence the animations
    requestAnimationFrame(() => {
      // 1. Circle pops in
      setTimeout(() => {
        this.circleTarget.style.transition = "transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease"
        this.circleTarget.style.transform = "scale(1)"
        this.circleTarget.style.opacity = "1"
      }, 100)

      // 2. Check pops in
      setTimeout(() => {
        this.checkTarget.style.transition = "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.2s ease"
        this.checkTarget.style.transform = "scale(1)"
        this.checkTarget.style.opacity = "1"
      }, 450)

      // 3. Ring pulse
      setTimeout(() => {
        this.ringTarget.style.transition = "transform 0.8s ease-out, opacity 0.8s ease-out"
        this.ringTarget.style.opacity = "0.4"
        this.ringTarget.style.transform = "scale(1)"
        requestAnimationFrame(() => {
          this.ringTarget.style.opacity = "0"
          this.ringTarget.style.transform = "scale(1.8)"
        })
      }, 500)

      // 4. Title slides up
      setTimeout(() => {
        this.titleTarget.style.transition = "transform 0.5s ease-out, opacity 0.5s ease-out"
        this.titleTarget.style.transform = "translateY(0)"
        this.titleTarget.style.opacity = "1"
      }, 700)
    })
  }
}
